<template>
  <div class="container">
    <div class="col-md-8 col-sm-10 mx-auto">
      <div name="notAllowed" v-if="!userIsInGroup('redeemers')">
        <h2>You shouldn't be here, should you?</h2>
      </div>
      <div name="errorDisplay" v-if="redeemError">
        <h3>Encountered an error!</h3>
        <p class="text-danger">{{ redeemError }}</p>
      </div>
      <div name="loadingMessage" v-if="loading || $apollo.loading">
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div name="redemptionInfo" v-if="!loading && !$apollo.loading">
        <div v-if="!gameInfo.redeemed">
          <h3>Claim your new game!</h3>
          <form>
            <div name="gameName" class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text"><font-awesome-icon icon="gamepad" fixed-width /></span>
              </div>
              <input type="text" class="form-control" v-model="gameInfo.name" readonly="readonly">
              <div class="input-group-append" v-if="browserSupportCopy">
                <button class="btn btn-outline-secondary" type="button" @click="copy(gameInfo.name)">
                  <font-awesome-icon icon="clipboard" fixed-width />
                </button>
              </div>
              <div class="input-group-append" v-if="isLink(gameInfo.name)">
                <a class="btn btn-outline-secondary" type="button" :href="gameInfo.name" target="_blank">
                  <font-awesome-icon icon="external" fixed-width />
                </a>
              </div>
            </div>
            <div name="gameKey" class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text"><font-awesome-icon icon="key" fixed-width /></span>
              </div>
              <input type="text" class="form-control" v-model="gameInfo.key" readonly="readonly">
              <div class="input-group-append" v-if="browserSupportCopy">
                <button class="btn btn-outline-secondary" type="button" @click="copy(gameInfo.key)">
                  <font-awesome-icon icon="clipboard" fixed-width />
                </button>
              </div>
              <div class="input-group-append" v-if="isLink(gameInfo.key)">
                <a class="btn btn-outline-secondary" type="button" :href="gameInfo.key" target="_blank">
                  <font-awesome-icon icon="external" fixed-width />
                </a>
              </div>
            </div>
            <div name="gameNotes" class="input-group mb-3" v-if="gameInfo.notes && gameInfo.notes.length">
              <div class="input-group-prepend">
                <span class="input-group-text"><font-awesome-icon icon="edit" fixed-width /></span>
              </div>
              <input type="text" class="form-control" v-model="gameInfo.notes" readonly="readonly">
              <div class="input-group-append" v-if="browserSupportCopy">
                <button class="btn btn-outline-secondary" type="button" @click="copy(gameInfo.notes)">
                  <font-awesome-icon icon="clipboard" fixed-width />
                </button>
              </div>
              <div class="input-group-append" v-if="isLink(gameInfo.notes)">
                <a class="btn btn-outline-secondary" type="button" :href="gameInfo.notes" target="_blank">
                  <font-awesome-icon icon="external" fixed-width />
                </a>
              </div>
            </div>
            <div name="dlcInfo" v-if="gameInfo.dlcs && gameInfo.dlcs.length">
              <h4>DLCs:</h4>
              <div v-for="(dlc, index) in gameInfo.dlcs" v-bind:key="index">
                <hr/>
                <div name="gameName" class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><font-awesome-icon icon="gamepad" fixed-width /></span>
                  </div>
                  <input type="text" class="form-control" v-model="dlc.name" readonly="readonly">
                  <div class="input-group-append" v-if="browserSupportCopy">
                    <button class="btn btn-outline-secondary" type="button" @click="copy(dlc.name)">
                      <font-awesome-icon icon="clipboard" fixed-width />
                    </button>
                  </div>
                  <div class="input-group-append" v-if="isLink(dlc.name)">
                    <a class="btn btn-outline-secondary" type="button" :href="dlc.name" target="_blank">
                      <font-awesome-icon icon="external" fixed-width />
                    </a>
                  </div>
                </div>
                <div name="gameKey" class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><font-awesome-icon icon="key" fixed-width /></span>
                  </div>
                  <input type="text" class="form-control" v-model="dlc.key" readonly="readonly">
                  <div class="input-group-append" v-if="browserSupportCopy">
                    <button class="btn btn-outline-secondary" type="button" @click="copy(dlc.key)">
                      <font-awesome-icon icon="clipboard" fixed-width />
                    </button>
                  </div>
                  <div class="input-group-append" v-if="isLink(dlc.key)">
                    <a class="btn btn-outline-secondary" type="button" :href="dlc.key" target="_blank">
                      <font-awesome-icon icon="external" fixed-width />
                    </a>
                  </div>
                </div>
                <div name="gameNotes" class="input-group mb-3" v-if="dlc.notes && dlc.notes.length">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><font-awesome-icon icon="edit" fixed-width /></span>
                  </div>
                  <input type="text" class="form-control" v-model="dlc.notes" readonly="readonly">
                  <div class="input-group-append" v-if="browserSupportCopy">
                    <button class="btn btn-outline-secondary" type="button" @click="copy(dlc.notes)">
                      <font-awesome-icon icon="clipboard" fixed-width />
                    </button>
                  </div>
                  <div class="input-group-append" v-if="isLink(dlc.notes)">
                    <a class="btn btn-outline-secondary" type="button" :href="dlc.notes" target="_blank">
                      <font-awesome-icon icon="external" fixed-width />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <button class="btn btn-success" type="button" @click="redeemKey()">Mark redeemed</button>
        </div>
        <div v-if="gameInfo.redeemed">
          <h3>This game key has been redeemed!</h3>
          <h4>By {{ gameInfo.redeemer }} {{ gameInfo.redeemTime | moment("from", "now") }}</h4>
          <button class="btn btn-danger" type="button" @click="unRedeemKey()">Wait! I didn't mean to mark it redeemed!</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'Redeem',
  props: ['user'],
  data() {
    return {
      gameInfo: {},
      redeemError: '',
      loading: false,
      browserSupportCopy: false
    }
  },
  mounted() {
    if (!this.userIsInGroup('redeemers')) {
      this.$router.push('/')
    }
  },
  created() {
    this.browserSupportCopy = !!navigator.clipboard;
  },
  methods: {
    userIsInGroup(group) {
      // The token payload holds an array of groups the user is in and indexOf will return the
      // index of the group name if it is found but -1 if it is not
      try {
        return this.user.signInUserSession.accessToken.payload['cognito:groups'].indexOf(group) > -1
      } catch {
        // User wasn't logged in so token didn't exist
        return false
      }
    },
    redeemKey() {
      this.loading = true
      var input = {
        KeyId: this.$route.params.gameId,
        redeemer: this.user.username
      }
      // Submit the mutation
      this.$apollo.mutate({
        mutation: gql`mutation ($KeyId: ID!, $redeemer: String!) {
          redeemKey(KeyId: $KeyId, redeemer: $redeemer) {
            KeyId
            name
            key
            notes
            redeemed
            redeemer
            redeemTime
            dlcs {
              name
              key
              notes
            }
          }
        }`,
        variables: input
      }).then((data) => {
        this.gameInfo = data.data.redeemKey
        // Update state variables
        this.loading = false
      }).catch((error) => {
        this.loading = false
        // Save error message
        this.redeemError = error
        // Scroll back to the error (have to wait until the DOM gets re-rendered)
        this.$nextTick(function(){
          window.scrollTo(0,0)
        })
      })
    },
    unRedeemKey() {
      this.loading = true
      var input = {
        KeyId: this.$route.params.gameId,
        redeemer: this.user.username,
        redeemed: false
      }
      // Submit the mutation
      this.$apollo.mutate({
        mutation: gql`mutation ($KeyId: ID!, $redeemer: String!, $redeemed: Boolean) {
          redeemKey(KeyId: $KeyId, redeemer: $redeemer, redeemed: $redeemed) {
            KeyId
            name
            key
            notes
            redeemed
            redeemer
            redeemTime
            dlcs {
              name
              key
              notes
            }
          }
        }`,
        variables: input
      }).then((data) => {
        this.gameInfo = data.data.redeemKey
        // Update state variables
        this.loading = false
      }).catch((error) => {
        this.loading = false
        // Save error message
        this.redeemError = error
        // Scroll back to the error (have to wait until the DOM gets re-rendered)
        this.$nextTick(function(){
          window.scrollTo(0,0)
        })
      })
    },
    async copy(content) {
      await navigator.clipboard.writeText(content)
    },
    isLink(str) {
      return /(https*:\/\/)*.+\..+/.test(str)
    }
  },
  apollo: {
    gameInfo: {
      query: gql`query getKey ($KeyId: ID!) {
        gameInfo: getKey(KeyId: $KeyId) {
          KeyId
          name
          key
          notes
          redeemed
          redeemer
          redeemTime
          dlcs {
            name
            key
            notes
          }
        }
      }`,
      variables () {
        return { KeyId: this.$route.params.gameId }
      }
    }
  }
}
</script>